var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"basic-subheader"},[(_vm.title)?_c('h5',{staticClass:"subheader-content__title mb-0"},[_vm._v(_vm._s(_vm.title))]):_c('div',{staticClass:"subheader-filters"},[_vm._t("filters")],2),_c('div',{staticClass:"subheader-content__actions"},[_vm._t("actions")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }